import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconPlusNotRounded: React.FC<IconProps> = ({color = 'var(--color-accent-1)'}): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 1V11M11 6L1 6" stroke={color} strokeWidth="1.1" strokeLinecap="round"/>
        </svg>
    </div>
);

export default IconPlusNotRounded;
